import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { useParams } from 'react-router-dom';
import { formatPhone } from '../utils/formatters';

const CheckinPage: React.FC = () => {
  const { type, id } = useParams<{ type: string; id: string }>();
  const [phone, setPhone] = useState('');
  const [name, setName] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');
  const [location, setLocation] = useState<{ lat: number; long: number } | null>(null);

  useEffect(() => {
    // Tentar pegar a localização ao carregar
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation({
            lat: position.coords.latitude,
            long: position.coords.longitude
          });
        },
        (error) => {
          console.warn("Geolocalização não permitida ou indisponível", error);
        }
      );
    }
  }, []);

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPhone(formatPhone(e.target.value));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('loading');
    
    try {
      const response = await api.post('/public/checkin/', {
        type,
        id,
        phone,
        name,
        lat: location?.lat,
        long: location?.long
      });
      
      setStatus('success');
      setMessage(`Olá, ${response.data.parent_name}! Sua presença foi confirmada.`);
    } catch (error: any) {
      setStatus('error');
      setMessage(error.response?.data?.error || 'Erro ao registrar presença. Verifique o telefone.');
    }
  };

  if (status === 'success') {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f0fdf4', padding: '20px' }}>
        <div style={{ textAlign: 'center', backgroundColor: 'white', padding: '40px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
          <div style={{ color: '#16a34a', fontSize: '4rem', marginBottom: '20px' }}>✓</div>
          <h2 style={{ color: '#166534' }}>Presença Confirmada!</h2>
          <p style={{ fontSize: '1.1rem', color: '#374151' }}>{message}</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f4f6f8', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <div className="card" style={{ width: '100%', maxWidth: '400px', padding: '30px' }}>
        <h2 style={{ textAlign: 'center', color: 'var(--primary-blue)', marginBottom: '10px' }}>Check-in Conecta</h2>
        <p style={{ textAlign: 'center', color: 'var(--text-secondary)', marginBottom: '30px' }}>
          Informe seu telefone para confirmar sua presença.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Seu Telefone (Cadastrado)</label>
            <input 
              type="text" 
              value={phone} 
              onChange={handlePhoneChange} 
              placeholder="(XX) XXXXX-XXXX"
              maxLength={15}
              required 
              style={{ fontSize: '1.2rem', padding: '15px', textAlign: 'center' }}
            />
          </div>
          
          <div className="form-group">
            <label>Seu Nome (Opcional)</label>
            <input 
              type="text" 
              value={name} 
              onChange={(e) => setName(e.target.value)} 
              placeholder="Para confirmação"
            />
          </div>

          {status === 'error' && (
            <div style={{ backgroundColor: '#fee2e2', color: '#b91c1c', padding: '10px', borderRadius: '8px', marginBottom: '20px', textAlign: 'center' }}>
              {message}
            </div>
          )}

          <button 
            type="submit" 
            className="btn" 
            style={{ width: '100%', padding: '15px', fontSize: '1.1rem' }}
            disabled={status === 'loading'}
          >
            {status === 'loading' ? 'Confirmando...' : 'Confirmar Presença'}
          </button>
        </form>
        
        <p style={{ textAlign: 'center', fontSize: '0.8rem', color: '#9ca3af', marginTop: '20px' }}>
          Sua localização será usada apenas para validar o check-in.
        </p>
      </div>
    </div>
  );
};

export default CheckinPage;
